import { SyncItemStatus, SyncItemStatusGroup, syncItemStatusGroup } from "@fusion-advantage/formlib"
import { useMemo } from "react"
import _ from 'lodash'

export interface SyncModalItem {
	name: string
	status: SyncItemStatus
}

const syncModelItemCompare = (a: SyncModalItem, b: SyncModalItem): number => {
	const aG = syncItemStatusGroup(a.status)
	const bG = syncItemStatusGroup(b.status)
	if(aG === bG) return 0
	// first loading items
	if(aG === SyncItemStatusGroup.Pending) return -1
	if(bG === SyncItemStatusGroup.Pending) return 1
	// then error
	if(aG === SyncItemStatusGroup.Error) return -1
	if(bG === SyncItemStatusGroup.Error) return 1
	// finally success
	if(aG === SyncItemStatusGroup.Success) return -1
	if(bG === SyncItemStatusGroup.Success) return 1
	// default: no change
	return 0
}

const sectionMaxItems = 8

export const useSyncModalItemSort = (items: SyncModalItem[]) => {
	return useMemo(() => {
		let items2 = [...items]
		// first reverse the whole list
		items2.reverse()
		// then sort by status
		items2.sort(syncModelItemCompare)
		// group for compressed visuals
		const byStatusGroupItems = _.groupBy(items, item => syncItemStatusGroup(item.status))
		const byStatusGroup = _.mapValues(byStatusGroupItems, (v) => v.length)
		const groupsRemain = (): number => {
			let groupCount = 0
			for(let count of Object.values(byStatusGroup)) {
				if(count > 0) {
					groupCount++
				}
			}
			return groupCount
		}
		// final output... singles (inferno) first,
		// then remainder in compressed groups.
		// in short we're compressing into groups as an easy way of keeping
		// the modal from becoming taller than the screen itself
		// when a clinician has several dozen appts on their schedule
		let items3: SyncModalItem[] = []
		for(let n = 1; n <= items2.length; n++) {
			let item = items2[n-1]
			if(n <= (sectionMaxItems - groupsRemain())) {
				let itemGroup = syncItemStatusGroup(item.status)
				byStatusGroup[itemGroup] = byStatusGroup[itemGroup] - 1
				items3.push(item)
			}
		}
		if(byStatusGroup[SyncItemStatusGroup.Pending] > 0) {
			items3.push({
				name: `... +${byStatusGroup[SyncItemStatusGroup.Pending]} Loading`,
				status: SyncItemStatus.Pending,
			})
		}
		if(byStatusGroup[SyncItemStatusGroup.Error] > 0) {
			items3.push({
				name: `... +${byStatusGroup[SyncItemStatusGroup.Error]} Error`,
				status: SyncItemStatus.Unknown,
			})
		}
		if(byStatusGroup[SyncItemStatusGroup.Success] > 0) {
			items3.push({
				name: `... +${byStatusGroup[SyncItemStatusGroup.Success]} Ok`,
				status: SyncItemStatus.Ok,
			})
		}
		return items3
	}, [items])
}
